import { udtLoginRequest, logoutRequest } from '@services'
import * as sdkInterface from '@plugins/sdkInterface.js'
import useFetchSubs from '@composables/useFetchSubs.js'
import { authStore } from '@stores'

const interfaceName = 'modioEmbedHub'
const DEBUG = false

function _debugLog(fnName, ...args) {
  if (DEBUG) {
    console.log(`${interfaceName}.${fnName}:`, ...args)
  }
}

/**
 * Echo the passed arguments back to the caller
 * @param  {...any} args - Arguments to echo
 * @returns {any} The passed arguments
 */
function echo(...args) {
  _debugLog('echo', args)
  return args
}

/**
 * Get a User Delegation Token for the current logged-in user
 * @returns {boolean} True if the user is logged in and token retrieval was initiated
 */
function getAuthToken() {
  const { isLoggedIn } = authStore()
  if (!isLoggedIn.value) {
    _debugLog('getAuthToken', 'user not logged in')
    return false
  }

  sdkInterface.setAuthToken()
  return true
}

/**
 * Login using a User Delegation Token
 * @param {string} udt - The UDT to exchange for an access token
 * @returns {void}
 */
function setAuthToken(udt) {
  udtLoginRequest(udt, true)
  _debugLog('setAuthToken')
}

/**
 * Check if the user is currently authenticated
 * @returns {boolean} True if user is logged in
 */
function isUserAuthenticated() {
  const { isLoggedIn } = authStore()
  const result = isLoggedIn.value
  _debugLog('isUserAuthenticated', result)
  return result
}

/**
 * Fetch the current user's subscriptions and update the store
 * @returns {void}
 */
function syncSubscriptions() {
  useFetchSubs().fetchSubs(true)
}

/**
 * Fetch the current user's purchases and update the store
 * @returns {void}
 */
function syncPurchases() {
  useFetchSubs().fetchPurchases(true)
}

/**
 * Log out the current user
 * @returns {void}
 */
function logout() {
  logoutRequest()
  _debugLog('logout')
}

globalThis[interfaceName] = {
  isUserAuthenticated,
  syncSubscriptions,
  syncPurchases,
  getAuthToken,
  setAuthToken,
  logout,
  echo,
}
